import React from "react";
import { useSelector } from "react-redux";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import CircularProgress from "@mui/material/CircularProgress";
import MUITourneyTableHeader from "./Headers/TourneyTableHeader";
import TournamentTableBody from "./Bodys/TournamentTableBody";
import { RootState, GameData, GamelistModalDetails } from "types";


interface PublicTournamentTableProps {
  setModalDets: (dets: GamelistModalDetails) => void;
  setGameData: (data: GameData) => void;
}

const PublicTournamentTable = (props: PublicTournamentTableProps) => {
  const pubTourneyList = useSelector((state: RootState) => state.games.publicTourneyList);

  if (!pubTourneyList) {
    return <CircularProgress />;
  }
  if (Object.keys(pubTourneyList).length) {
    return (
      <TableContainer component={Paper} elevation={5}>
        <Table className="tablelist" aria-label="public tournament table">
          <MUITourneyTableHeader />
          <TournamentTableBody data={pubTourneyList} {...props} />
        </Table>
      </TableContainer>
    );
  }
  return <div>No Public Tournaments Found </div>;
};

export default PublicTournamentTable;
